import React from 'react';
import Image from 'next/legacy/image';

type TBigQuoteProps = {
  quote: string;
  name: string;
  titles: string[];
  imageURL: string;
};

export const BigQuote: React.FC<TBigQuoteProps> = ({
  quote,
  name,
  titles,
  imageURL
}) => (
  <div className="relative mx-auto max-w-7xl overflow-hidden px-4 pt-20 pb-12 sm:px-6 lg:px-8 lg:py-20">
    <div className="relative items-center lg:flex lg:items-center">
      <div className="hidden overflow-hidden rounded-full lg:flex lg:flex-shrink-0">
        <Image src={imageURL} width="200" height="200" alt="av" />
      </div>

      <div className="relative lg:ml-10">
        <svg
          className="absolute top-0 left-0 h-36 w-36 -translate-x-8 -translate-y-24 transform text-clerk-blue opacity-20"
          stroke="currentColor"
          fill="none"
          viewBox="0 0 144 144"
          aria-hidden="true"
        >
          <path
            strokeWidth={2}
            d="M41.485 15C17.753 31.753 1 59.208 1 89.455c0 24.664 14.891 39.09 32.109 39.09 16.287 0 28.386-13.03 28.386-28.387 0-15.356-10.703-26.524-24.663-26.524-2.792 0-6.515.465-7.446.93 2.327-15.821 17.218-34.435 32.11-43.742L41.485 15zm80.04 0c-23.268 16.753-40.02 44.208-40.02 74.455 0 24.664 14.891 39.09 32.109 39.09 15.822 0 28.386-13.03 28.386-28.387 0-15.356-11.168-26.524-25.129-26.524-2.792 0-6.049.465-6.98.93 2.327-15.821 16.753-34.435 31.644-43.742L121.525 15z"
          />
        </svg>
        <blockquote className="relative">
          <div className="text-2xl font-medium leading-9 text-gray-900">
            <p>{quote}</p>
          </div>
          <footer className="mt-8">
            <div className="flex">
              <div className="flex w-14 flex-shrink-0 items-center overflow-hidden rounded-full lg:hidden">
                <Image src={imageURL} width="200" height="200" alt="av" />
              </div>
              <div className="ml-4 lg:ml-0">
                <div className="text-base font-medium text-gray-900">
                  {name}
                </div>
                {titles.map(title => (
                  <div
                    key={title}
                    className="text-base font-medium text-clerk-blue"
                  >
                    {title}
                  </div>
                ))}
              </div>
            </div>
          </footer>
        </blockquote>
      </div>
    </div>
  </div>
);

export default BigQuote;
